import { makeAutoObservable } from 'mobx';

import { whatsNewService } from '../services/whatsNewService';
import { resetAllStore } from '../../shared/stores/resetAllStore';

class WhatsNewStore {
  open: boolean = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.open = false;
  }

  async getModalStatus(userId: number) {
    const { show } = await whatsNewService.getShowStatus(userId);

    this.setOpen(show);
  }

  openModal() {
    this.setOpen(true);
  }

  closeModal() {
    this.setOpen(false);
  }

  private setOpen = (open: boolean) => {
    this.open = open;
  };
}

const whatsNewStore = new WhatsNewStore();
resetAllStore.addResetMethod(whatsNewStore.setDefaultValues);

export { whatsNewStore };
